module.exports = __webpack_public_path__ + "static/img/50W.85e98fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/06/50W.png
// module id = KUAQ
// module chunks = 2